/* eslint-disable react/no-children-prop */
import React, { Component } from 'react';
import {
  Card, CardBody, Col, Badge, Table, Spinner, Button
} from 'reactstrap';
import moment from 'moment';
import { Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import DownloadIcon from 'mdi-react/CloudDownloadIcon';
import PropTypes from 'prop-types';
import { _capitalizeText } from '../../../shared/helpers/utils';
import { _axiosCall } from '../../../shared/helpers/apicalls';
import LinearLoading from '../../../shared/components/LinearLoading';

const apiUrl = process.env.API_ROOT + '/buyerslist/';
const ITEMS_PER_PAGE = 10;

class Receipts extends Component {
  constructor(props) {
	super(props);
	this.state = {
	  loading: true,
	  receipts: [],
	  startingAfterStack: [],
	  nextStartingAfter: null,
	  hasMore: false,
	};
  }

  componentDidMount() {
	const user = this.props.user;
	if (user && user.customerId) {
	  this._getReceipts(user.customerId, null);
	} else {
	  this.setState({ loading: false });
	}
  }

  _getReceipts = function(customer, starting_after) {
	var userData = {
	  url: apiUrl + 'stripe/get-receipts',
	  method: 'post',
	  query: {
		customer: customer,
		limit: ITEMS_PER_PAGE,
		starting_after: starting_after
	  }
	};

	var self = this;
	self.setState({ loading: true });

	_axiosCall(userData)
	  .then(function(res) {
		if (res && res.data) {
		  self.setState({
			receipts: res.data,
			loading: false,
			hasMore: res.has_more,
			nextStartingAfter: res.next_starting_after
		  });
		} else {
		  self.setState({ receipts: [], loading: false });
		}
	  })
	  .catch(function(error) {
		console.log('_getReceipts error', error);
		self.setState({ receipts: [], loading: false });
	  });
  }.bind(this);

  _handleNext = function() {
	const user = this.props.user;
	const stack = this.state.startingAfterStack.slice();
	stack.push(this.state.receipts[this.state.receipts.length - 1].id);

	this.setState({ startingAfterStack: stack }, function() {
	  this._getReceipts(user.customerId, this.state.nextStartingAfter);
	});
  }.bind(this);

  _handlePrev = function() {
	const user = this.props.user;
	const stack = this.state.startingAfterStack.slice();
	const prevStartingAfter = stack.length > 1 ? stack[stack.length - 2] : null;
	stack.pop();

	this.setState({ startingAfterStack: stack }, function() {
	  this._getReceipts(user.customerId, prevStartingAfter);
	});
  }.bind(this);

  render() {
	var receipts = this.state.receipts;
	var loading = this.state.loading;
	var hasMore = this.state.hasMore;
	var pageStack = this.state.startingAfterStack;
	if(receipts.length === 0) return null;
	return (
	  <Col md={12} lg={12}>
		<Card>
		  <CardBody>
			<div className="card__title">
			  <h5 className="bold-text">Payment History</h5>
			  <h5 className="subhead" />
			</div>

			{loading ? (
			  null
			) : receipts.length === 0 ? (
			  <div style={{ padding: '1rem' }}>No receipts found.</div>
			) : (
			  <div>
				<Table striped responsive>
				  <thead>
					<tr>
					  <th></th>
					  <th>Date</th>
					  <th>Amount</th>
					  <th>Payment Method</th>
					  <th>Item</th>
					  <th>Status</th>
					</tr>
				  </thead>
				  <tbody>
					{receipts.map(function(intent) {
					  var charge = intent.charges && intent.charges.data && intent.charges.data.length > 0
						? intent.charges.data[0]
						: null;

					  return (
						<tr key={intent.id}>
						  <td style={{ padding: '3px 5px' }}>
							<Tooltip title="Download Receipt PDF">
							  <IconButton
								className="material-table__toolbar-button"
								onClick={function(e) { e.stopPropagation(); }}
							  >
								{charge && charge.receipt_url ? (
								  <DownloadIcon size={18} onClick={function() { window.open(charge.receipt_url); }} />
								) : null}
							  </IconButton>
							</Tooltip>
						  </td>
						  <td>{moment.unix(intent.created).format('L LT')}</td>
						  <td>${(intent.amount / 100).toFixed(2)}</td>
						  <td>
							{charge && charge.payment_method_details &&
							  charge.payment_method_details.card &&
							  _capitalizeText(charge.payment_method_details.card.brand) + ' ****' + charge.payment_method_details.card.last4}
						  </td>
						  <td>
							{charge && charge.description ? (
							  <p>{charge.description}</p>
							) : '-'}
						  </td>
						  <td>
							{intent.status === 'succeeded' ? (
							  <Badge color="success">{_capitalizeText(intent.status)}</Badge>
							) : (
							  <Badge>{_capitalizeText(intent.status)}</Badge>
							)}
						  </td>
						</tr>
					  );
					})}
				  </tbody>
				</Table>

				<div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
				  <Button disabled={pageStack.length === 0} onClick={this._handlePrev}>Prev</Button>
				  <div style={{ paddingTop: '7px' }}>Page {pageStack.length + 1}</div>
				  <Button disabled={!hasMore} onClick={this._handleNext}>Next</Button>
				</div>
			  </div>
			)}
		  </CardBody>
		</Card>
	  </Col>
	);
  }
}

Receipts.propTypes = {
  user: PropTypes.object.isRequired
};

export default Receipts;
